import {
  DataViewHeader,
  Flex,
  FlexSpacer,
  Pagination,
  Stack,
  csx,
} from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'
import { usePromotionsListState } from '../usePromotionsListState'

export function TableToolbar(props: DefaultProps) {
  const { paginationState } = usePromotionsListState()

  return (
    <DataViewHeader>
      <Flex direction="row" align="center" className={csx({ width: 'full' })}>
        <Stack
          direction="row"
          space="$space-3"
          className={csx({ width: 'full' })}
        >
          {props.children}
        </Stack>

        <FlexSpacer />
        <Pagination state={paginationState} />
      </Flex>
    </DataViewHeader>
  )
}
